export default __webpack_public_path__ + "static/media/HeaderImg(1).c0796cda.png";